module.exports = __webpack_public_path__ + "img/43.6e08bd90.png";